module.exports = "<img *ngIf=\"src\" [src]=\"src\" style=\"width: 100%\" />\n<canvas #canvas hidden></canvas>\n"